import { PARTNERS_TABS } from "@/Routes/partnerSidebar.utility";
import { handleErrorToast } from "@repo/ui/libs";
import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { handleGlobalGetRequestQuery } from "@repo/api-services/getRequestsGlobal.ts";
import queryClientGlobal from "@repo/api-services/queryConfig.ts";
import URLS from "@repo/api-services/URLS";
import { stringUtility } from "@repo/utilities/string.utility.ts";

export const getRedirectPathFromAuth = async () => {
  await queryClientGlobal.invalidateQueries({
    queryKey: CACHE_KEYS.AUTH_USER,
  });

  // The user data is already updated. We are using fetch query juts for the sole purpose of getting the response.
  const authUserResponse = await queryClientGlobal.fetchQuery({
    queryKey: CACHE_KEYS.AUTH_USER,
    queryFn: () => handleGlobalGetRequestQuery({ url: URLS.AUTH_USER }),
  });

  const permissionsMap = authUserResponse?.permissions;

  // For admin who have all the permissions, redirect to the first tab
  if (Array.isArray(permissionsMap) && permissionsMap.includes("*")) {
    return PARTNERS_TABS[0].subTabs
      ? PARTNERS_TABS[0].subTabs[0].path
      : PARTNERS_TABS[0].path;
  }

  const accessibleTabCodes = new Set<string>(
    Object.keys(permissionsMap).map((permissionKey) =>
      stringUtility.replaceCharAll(permissionKey, "_", "-")
    )
  );

  const firstAccessibleTab = PARTNERS_TABS.flatMap(
    (tab) => tab.subTabs ?? [tab]
  ).find((tab) => accessibleTabCodes.has(tab.code));

  if (!firstAccessibleTab) {
    localStorage.clear();
    handleErrorToast({
      message:
        "You do not have access to any page. Please contact administrator.",
    });
    return "/login";
  }

  return firstAccessibleTab.path;
};
